import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useMemo } from 'react';
import Body from './Body';
import Footer from './Footer';
import Header from './Header';
import ProgressBar from './ProgressBar';
import PropertyCardContext from './PropertyCardContext';
import { PropertyCardWrapper } from './PropertyCard.style';
const PropertyCard = ({ children, id, navigateTo }) => {
    const [isCardSelected, setIsCardSelected] = useState(false);
    const propertyCardContext = useMemo(() => ({
        isCardSelected
    }), [isCardSelected]);
    const handleClick = () => {
        if (navigateTo) {
            navigateTo();
        }
    };
    return (_jsx(PropertyCardWrapper, { id: id, onMouseEnter: () => setIsCardSelected(true), onMouseLeave: () => setIsCardSelected(false), onClick: handleClick, children: _jsx(PropertyCardContext.Provider, { value: propertyCardContext, children: children }) }));
};
PropertyCard.Header = Header;
PropertyCard.ProgressBar = ProgressBar;
PropertyCard.Body = Body;
PropertyCard.Footer = Footer;
export default PropertyCard;
